<template>
  <div id="app">
    <transition
      name="fade"
      mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default { name: "App" }
</script>

<style lang="scss">
#app {
  height: 100%;
  padding: 16px;
}
</style>
